import { Link } from "react-router";

const mono = { fontFamily: "var(--font-mono)", fontVariantNumeric: "tabular-nums" as const };

const FOOT_LINKS = [
  {
    h: "Product",
    links: [
      { label: "Voice Agent", path: "/product#voice-agent" },
      { label: "Bookings & scheduling", path: "/product#bookings" },
      { label: "Missed-call rescue", path: "/product#missed-call-rescue" },
      { label: "Call log & transcripts", path: "/product#call-log" },
      { label: "Workflows", path: "/product#workflows" },
      { label: "Pricing", path: "/pricing" },
    ],
  },
  {
    h: "Industries",
    links: [
      { label: "Home services", path: "/industries/home-services" },
      { label: "HVAC", path: "/industries/hvac" },
      { label: "Hospitality", path: "/industries/hospitality" },
      { label: "Legal & insurance", path: "/industries/legal" },
      { label: "All industries", path: "/industries" },
    ],
  },
  {
    h: "Company",
    links: [
      { label: "About", path: "/about" },
      { label: "Customers", path: "/customers" },
      { label: "Careers", path: "/careers" },
      { label: "Contact sales", path: "/contact" },
      { label: "Sign in", path: "/login" },
    ],
  },
  {
    h: "Legal",
    links: [
      { label: "Privacy policy", path: "/privacy-policy" },
      { label: "Terms of service", path: "/terms-of-service" },
      { label: "Disclaimer", path: "/disclaimer" },
    ],
  },
];

export function MarketingFooter() {
  return (
    <footer
      style={{
        background: "var(--ink-950)",
        borderTop: "1px solid var(--ink-800)",
        padding: "72px 0 48px",
        color: "var(--ink-400)",
      }}
    >
      <div className="max-w-[1160px] mx-auto px-6 sm:px-9">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-12">
          <div className="sm:col-span-2 lg:col-span-1">
            <span className="flex items-center gap-2.5">
              <img src="/mark-dark.svg" width="32" height="32" alt="" />
              <span
                className="font-extrabold text-[20px] tracking-[-0.02em]"
                style={{ fontFamily: "var(--font-display)", color: "var(--ink-50)" }}
              >
                Attenzio
              </span>
            </span>
            <p className="text-[14px] mt-4 leading-relaxed" style={{ maxWidth: "280px", color: "var(--ink-400)" }}>
              Supervised AI call intake for local businesses. Pilot scope agreed before launch.
            </p>
            <div
              className="mt-5 inline-flex items-center gap-2 rounded-[var(--radius-sm)] px-3 py-1.5"
              style={{
                ...mono,
                fontSize: "11px",
                letterSpacing: "0.06em",
                color: "var(--blue-300)",
                border: "1px solid var(--ink-700)",
                background: "var(--ink-900)",
              }}
            >
              <span
                className="w-1.5 h-1.5 rounded-full"
                style={{ background: "var(--green-500)", boxShadow: "0 0 0 3px rgba(39,192,107,0.2)" }}
              />
              SUPERVISED PILOTS
            </div>
          </div>
          {FOOT_LINKS.map((col) => (
            <div key={col.h}>
              <div
                className="uppercase tracking-[0.08em] mb-4"
                style={{ ...mono, fontSize: "11px", color: "var(--ink-400)" }}
              >
                {col.h}
              </div>
              <div className="flex flex-col">
                {col.links.map((l) => (
                  <Link
                    key={l.label}
                    to={l.path}
                    className="py-1.5 transition-colors"
                    style={{ color: "var(--ink-200)", fontSize: "14px", textDecoration: "none" }}
                    onMouseEnter={(e) => (e.currentTarget.style.color = "var(--ink-50)")}
                    onMouseLeave={(e) => (e.currentTarget.style.color = "var(--ink-200)")}
                  >
                    {l.label}
                  </Link>
                ))}
              </div>
            </div>
          ))}
        </div>
        <div
          className="flex flex-col sm:flex-row items-center justify-between gap-4 mt-14 pt-6"
          style={{ borderTop: "1px solid var(--ink-800)", fontSize: "13px", color: "var(--ink-400)" }}
        >
          <span>© 2026 Attenzio</span>
          <span className="uppercase tracking-[0.08em]" style={{ ...mono, fontSize: "11px" }}>
            Attention on every call
          </span>
        </div>
      </div>
    </footer>
  );
}
